import React from "react"
import styled from "styled-components"
import { ArrowRight } from "@styled-icons/bootstrap"

const Container = styled.div``

const Image = styled.img`
	height: 366px;
	width: 286px;
	&:after {
		content: "\A";
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.6);
		opacity: 0;
		transition: all 1s;
		-webkit-transition: all 1s;
	}
`

const Title = styled.h4`
	color: #ffffff;
	font-family: Mallory;
	font-size: 18px;
	font-weight: 300;
	letter-spacing: 0;
	line-height: 22px;
	margin: 0;
	text-transform: capitalize;
	margin-bottom: 11px;
`

const BlogContainer = styled.div`
	flex: 0 1 22%;
	margin: 0 16px;
	height: 366px;
	width: 286px;
	background-size: cover;
	position: relative;
	@media (max-width: 767px) {
		height: 217px;
		width: 157px;
	}
	@media (max-width: 1020px) {
		flex: 0 1 19%;
	}
`

const TextBlock = styled.div`
	position: absolute;
	bottom: 24px;
	left: 24px;
`

const View = styled.p`
	font-family: Mallory;
	font-size: 13px;
	font-weight: 300;
	letter-spacing: 1px;
	line-height: 16px;
	color: #ffffff;
	text-transform: uppercase;
`

const Arrow = styled(ArrowRight)`
	color: #ffffff;
	margin-left: 8px;
`

export const RelatedBlog = ({ data, value }) => {
	const image = data.results[0].data.featured_image.url
	const title = data.results[0].slugs

	return (
		<>
			<BlogContainer
				style={{
					backgroundImage:
						"linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('" +
						image +
						"')",
				}}
			>
				<TextBlock>
					<Title>{title}</Title>
					<View>
						View
						<Arrow size="15" />
					</View>
				</TextBlock>
			</BlogContainer>
		</>
	)
}
